export const fileSizeConverter = (sizeInMb: number): number => {
  const sizeInMB = (sizeInMb / (1024 * 1024)).toFixed(2);
  return Number(sizeInMB);
};
